import { isUserSubscribed } from 'Api/courseDetailsEvaluations';
import { useSelector } from 'react-redux';
import { userSelector } from 'Redux/LoggedUserSlice';
import { useState, useEffect } from 'react';

const useIsUserSub = courseId => {
  const [isUserSub, setIsUserSub] = useState();
  const { id } = useSelector(userSelector);

  useEffect(() => {
    isUserSubscribed({ courseId, userId: id }).then(data => {
      setIsUserSub(data);
    });
  }, [courseId]);

  return { isUserSub };
};

export default useIsUserSub;
